export default {
  translation: {
    // Common
    common: {
      back: 'Back',
      session: 'Session',
      topic: 'Topic',
      players: 'Players',
      loading: 'Loading...',
      error: 'Error',
      copy: 'Copy',
      copied: 'Copied!',
      remove: 'Remove',
      logout: 'Logout',
      or: 'or',
    },

    // Login Page
    login: {
      title: 'Planning Poker',
      subtitle: 'Sign in to continue',
      signInWithGitHub: 'Sign in with GitHub',
      signInWithGitLab: 'Sign in with GitLab',
      info: 'Sign in with your GitHub or GitLab account to use Planning Poker',
      errors: {
        loginFailed: 'Login failed. Please try again.',
      },
    },

    // Home Page
    home: {
      title: 'Planning Poker',
      subtitle: 'Real-time Scrum Poker for your Team',
      startSession: 'Start Session',
      asModerator: 'As Moderator',
      or: 'or',
      enterCode: 'Enter Session Code',
      yourName: 'Your Name',
      join: 'Join',
      whatIs: 'What is Planning Poker?',
      description: 'Planning Poker is an agile estimation method where teams collaboratively assess the complexity of tasks.',
      feature1: 'Moderator creates a session and sets a topic',
      feature2: 'Players join with a code',
      feature3: 'Everyone votes simultaneously',
      feature4: 'Moderator reveals the cards',
      errors: {
        noCode: 'Please enter a session code',
        noName: 'Please enter your name',
      },
    },

    // Moderator Page
    moderator: {
      title: 'Planning Poker - Moderator',
      createNewSession: 'Create New Session',
      startSession: 'Start Session',
      sessionCode: 'Session Code',
      playersCanJoin: 'Players can join with this code',
      copyUrl: 'Copy URL',
      openPlayerView: 'Open Player View',
      currentTopic: 'Current Topic',
      topicPlaceholder: 'e.g. User Story: Implement Login',
      setTopic: 'Set Topic',
      votedCount: '{{count}} of {{total}} have voted',
      revealCards: 'Reveal Cards',
      newRound: 'New Round',
      results: 'Results',
      statistics: 'Statistics',
      average: 'Average',
      median: 'Median',
      min: 'Min',
      max: 'Max',
      votes: 'vote',
      votes_plural: 'votes',
      waitingForTopic: 'Waiting for topic...',
      errorCreating: 'Error creating session',
      roundHistory: 'Round History',
      round: 'Round',
      noRoundsYet: 'No completed rounds yet',
      participants: 'Participants',
      linkedIssue: 'Linked Issue',
      optional: 'optional',
      issueUrlPlaceholder: 'e.g. https://github.com/owner/repo/issues/123',
      issueTitlePlaceholder: 'Issue title (optional)',
      linkIssue: 'Link Issue',
      issueError: 'Error linking issue',
      issueHint: 'Enter GitHub or GitLab issue URL',
      exportResults: 'Export Results',
      exportCSV: 'Export CSV',
      exportJSON: 'Export JSON',
      exportPDF: 'Export PDF',
      playerMenu: 'Player menu',
      kickPlayer: 'Remove',
      kickConfirm: 'Do you really want to remove {{name}} from the session?',
      kickError: 'Failed to remove player',
    },

    // Player Page
    player: {
      title: 'Planning Poker',
      connectingToSession: 'Connecting to session...',
      invalidParams: 'Invalid session parameters',
      sessionNotFound: 'Session not found',
      backToHome: 'Back to Home',
      currentTopic: 'Current Topic',
      waitingForTopic: 'Waiting for topic...',
      chooseCard: 'Choose your card',
      yourVote: 'Your vote',
      you: 'You',
      resultsTitle: 'Results',
      connectionLost: 'Connection to server lost',
      roundHistory: 'Round History',
      round: 'Round',
      noRoundsYet: 'No completed rounds yet',
      linkedIssue: 'Linked Issue',
    },

    // Issue Search
    issueSearch: {
      assignedToMe: 'Assigned to me',
      createdByMe: 'Created by me',
    },

    // Footer
    footer: {
      impressum: 'Legal Notice',
      datenschutz: 'Privacy Policy',
      spielanleitung: 'How to Play',
      faq: 'FAQ',
      allRightsReserved: 'All rights reserved.',
    },

    // SEO / Meta Tags
    seo: {
      home: {
        title: 'Planning Poker - Real-time Scrum Poker for Agile Teams',
        description: 'Planning Poker is an agile estimation method for teams. Create sessions, invite team members, and collaboratively estimate the complexity of tasks in real-time.',
        keywords: 'Planning Poker, Scrum Poker, Agile Estimation, Sprint Planning, Team Collaboration, Scrum, Agile, Story Points',
      },
      impressum: {
        title: 'Legal Notice - Planning Poker',
        description: 'Legal notice and legal information for Planning Poker according to § 5 TMG.',
      },
      datenschutz: {
        title: 'Privacy Policy - Planning Poker',
        description: 'Privacy policy for Planning Poker. Information about data processing according to GDPR.',
      },
      spielanleitung: {
        title: 'How to Play - Planning Poker',
        description: 'Comprehensive guide on how to use Planning Poker. Learn how to create sessions, invite team members, and effectively estimate story points.',
        keywords: 'Planning Poker Guide, How to Play, Scrum Poker Tutorial, Agile Estimation, Story Points, Sprint Planning Guide',
      },
      faq: {
        title: 'FAQ - Frequently Asked Questions - Planning Poker',
        description: 'Frequently asked questions about Planning Poker. Find quick answers to the most important questions about usage, sessions, cards, and more.',
        keywords: 'Planning Poker FAQ, Frequently Asked Questions, Planning Poker Help, Scrum Poker Questions, Agile Estimation FAQ',
      },
      siteName: 'Planning Poker',
      author: 'Planning Poker Team',
    },

    // Impressum Page
    impressum: {
      title: 'Legal Notice',
      provider: 'Information according to § 5 TMG',
      companyName: 'Sample Company Ltd.',
      street: '123 Sample Street',
      cityZip: '12345 Sample City',
      country: 'Germany',
      contact: 'Contact',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      representative: 'Represented by',
      representativeName: 'John Doe (Managing Director)',
      registrationTitle: 'Register Entry',
      registrationCourt: 'Registration Court',
      registrationNumber: 'Registration Number',
      vatId: 'VAT ID',
      responsibleForContent: 'Responsible for content according to § 55 Abs. 2 RStV',
      responsibleName: 'John Doe',
      disputeResolution: 'Dispute Resolution',
      disputeText: 'The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr. You can find our email address in the legal notice above. We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
      liability: 'Liability Disclaimer',
      liabilityContent: 'As a service provider, we are responsible for our own content on these pages in accordance with § 7 para.1 TMG under general law. According to §§ 8 to 10 TMG, however, we are not obligated as a service provider to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.',
      liabilityLinks: 'Our offer contains links to external third-party websites over whose content we have no influence. Therefore, we cannot assume any liability for this external content. The respective provider or operator of the pages is always responsible for the content of the linked pages.',
    },

    // Datenschutz Page
    datenschutz: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated',
      overview: 'Overview',
      overviewText: 'The protection of your personal data is of particular concern to us. We therefore process your data exclusively on the basis of legal provisions (GDPR, TKG 2003). In this privacy policy, we inform you about the most important aspects of data processing within our website.',
      responsibleParty: 'Responsible Party',
      dataCollection: 'Data Collection on this Website',
      cookies: 'Cookies',
      cookiesText: 'Our website uses cookies. Cookies are small text files that are stored on your device and saved by your browser. Cookies serve to make our offer more user-friendly, effective and secure. Most of the cookies we use are so-called session cookies, which are automatically deleted after closing the browser.',
      serverLogs: 'Server Log Files',
      serverLogsText: 'Every time you access our website, information is automatically stored in server log files that your browser automatically transmits. These are:',
      browserType: 'Browser type and browser version',
      browserVersion: 'Operating system used',
      operatingSystem: 'Operating system used',
      referrerUrl: 'Referrer URL',
      hostname: 'Hostname of the accessing computer',
      accessTime: 'Time of server request',
      ipAddress: 'IP address',
      authentication: 'Authentication (GitHub/GitLab)',
      authText: 'When you sign in via GitHub or GitLab, we collect the following data from your GitHub/GitLab profile:',
      authName: 'Name',
      authEmail: 'Email address',
      authAvatar: 'Profile picture',
      authUsername: 'Username',
      yourRights: 'Your Rights',
      rightsIntro: 'You have the right to information, correction, deletion, restriction, data portability, revocation and objection. If you believe that the processing of your data violates data protection law or your data protection rights have been violated in any other way, you can complain to the supervisory authority.',
      rightAccess: 'Access',
      rightAccessText: 'You have the right to request information about your personal data processed by us.',
      rightCorrection: 'Correction',
      rightCorrectionText: 'You have the right to request the immediate correction of incorrect personal data concerning you.',
      rightDeletion: 'Deletion',
      rightDeletionText: 'You have the right to request the deletion of your personal data.',
      rightRestriction: 'Restriction of Processing',
      rightRestrictionText: 'You have the right to request the restriction of the processing of your personal data.',
      rightPortability: 'Data Portability',
      rightPortabilityText: 'You have the right to receive your personal data in a structured, common format.',
      rightObjection: 'Objection',
      rightObjectionText: 'You have the right to object to the processing of your personal data.',
      dataSecurity: 'Data Security',
      dataSecurityText: 'We use the widespread SSL (Secure Socket Layer) method in conjunction with the highest level of encryption supported by your browser when visiting our website. This is usually 256-bit encryption. If your browser does not support 256-bit encryption, we use 128-bit v3 technology instead.',
      thirdParty: 'Third-Party Services',
      thirdPartyText: 'We use the following third-party services:',
      supabaseText: 'We use Supabase for authentication and data storage. For more information, see the Supabase Privacy Policy: https://supabase.com/privacy',
      sentryText: 'We use Sentry for error tracking and monitoring. For more information, see the Sentry Privacy Policy: https://sentry.io/privacy/',
      contact: 'Contact',
      contactText: 'If you have any questions about the collection, processing or use of your personal data, for information, correction, blocking or deletion of data, please contact the address given in the legal notice.',
    },

    // Spielanleitung Page
    spielanleitung: {
      title: 'How to Play',
      subtitle: 'How does Planning Poker work?',
      intro: 'Planning Poker is an estimation method for agile teams that helps collaboratively assess the effort of user stories. This guide walks you through all the steps.',

      // For Moderators
      forModerators: 'For Moderators',
      moderatorIntro: 'As a moderator, you are responsible for organizing and managing the Planning Poker session.',

      step1Title: 'Step 1: Create Session',
      step1Text: 'Click "Start Session" on the home page. You will be automatically logged in as a moderator and receive a unique 6-digit session code.',

      step2Title: 'Step 2: Invite Team',
      step2Text: 'Share the session code or the full URL with your team. Players can enter the code on the home page or join directly via the link.',

      step3Title: 'Step 3: Set Topic',
      step3Text: 'Enter the current estimation topic (e.g., "User Story: Implement login function"). Optionally, you can also link a GitHub or GitLab issue.',

      step4Title: 'Step 4: Start Voting',
      step4Text: 'Once all players have chosen their cards, you will see the number of votes cast. Click "Reveal Cards" to show the results.',

      step5Title: 'Step 5: Discuss Results',
      step5Text: 'You will see all votes, the average, median, and min/max values. Discuss deviations with the team and start a new round if needed.',

      step6Title: 'Step 6: Next Round',
      step6Text: 'Click "New Round" to estimate the next topic. The history of all rounds is automatically saved.',

      // For Players
      forPlayers: 'For Players',
      playerIntro: 'As a player, you participate in the estimation and provide your assessment of the task complexity.',

      playerStep1Title: 'Step 1: Join Session',
      playerStep1Text: 'Enter the 6-digit session code and your name on the home page. Click "Join" to join the session.',

      playerStep2Title: 'Step 2: Read Topic',
      playerStep2Text: 'Carefully read the topic set by the moderator. If an issue is linked, you can open it directly.',

      playerStep3Title: 'Step 3: Choose Card',
      playerStep3Text: 'Choose a card that matches your assessment of the complexity. The Fibonacci sequence (1, 2, 3, 5, 8, 13, 21) is used by default.',

      playerStep4Title: 'Step 4: Wait for Reveal',
      playerStep4Text: 'Wait until all players have chosen. The moderator will then reveal the cards and show the results.',

      playerStep5Title: 'Step 5: Discussion',
      playerStep5Text: 'Discuss with your team about the different estimates, especially when there are large deviations.',

      // Card Values
      cardValues: 'Card Values',
      cardValuesText: 'Planning Poker typically uses the Fibonacci sequence to account for increasing uncertainty with larger tasks:',
      cardValue1: '1, 2, 3: Small, simple tasks',
      cardValue2: '5, 8: Medium tasks with moderate complexity',
      cardValue3: '13, 21: Large, complex tasks',
      cardValue4: '?: Uncertainty, more information needed',
      cardValue5: '☕: Break needed',

      // Tips
      tips: 'Tips for Successful Estimations',
      tip1: 'Discuss the requirements thoroughly before estimating',
      tip2: 'Avoid "anchoring" - reveal cards simultaneously',
      tip3: 'For large deviations: Let the highest and lowest estimates explain their perspective',
      tip4: 'Use the break card (☕) when a discussion runs too long',
      tip5: 'Split very large tasks (21+) into smaller stories',
      tip6: 'The ? card indicates that more information is needed',

      // Features
      features: 'Additional Features',
      feature1Title: 'Round History',
      feature1Text: 'All completed rounds are saved and can be viewed at any time.',
      feature2Title: 'Issue Linking',
      feature2Text: 'Link GitHub or GitLab issues directly with your estimates.',
      feature3Title: 'Real-time Updates',
      feature3Text: 'All changes are transmitted to all participants in real-time.',
      feature4Title: 'Dark Mode',
      feature4Text: 'Choose between light and dark design for comfortable working.',
      feature5Title: 'Multilingual',
      feature5Text: 'The application is available in German and English.',
    },

    // FAQ Page
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find quick answers to the most important questions about Planning Poker',
      moreHelp: 'Need more help?',
      moreHelpText: 'Visit our comprehensive guide for detailed information on using Planning Poker.',
      viewGuide: 'View Guide',

      q1: 'What is Planning Poker?',
      a1: 'Planning Poker (also called Scrum Poker) is an agile estimation technique used by development teams to estimate the effort or relative size of tasks in software development. The method leverages the wisdom of the crowd and avoids cognitive biases such as anchoring effects.',

      q2: 'How do I start a Planning Poker session?',
      a2: 'Click "Start Session" on the home page. You will be logged in as a moderator and receive a unique 6-digit session code. Share this code with your team so they can join.',

      q3: 'Can I participate without signing in?',
      a3: 'Yes! As a player, you can participate without signing in - you only need the session code and your name. Only moderators need to sign in with GitHub or GitLab to create sessions.',

      q4: 'What card values are used?',
      a4: 'We use the modified Fibonacci sequence: 1, 2, 3, 5, 8, 13, 21. Additionally, there are special cards:\n• ? (Question mark) - When you\'re uncertain or need more information\n• ☕ (Coffee cup) - When you need a break\n\nThe Fibonacci sequence reflects the increasing uncertainty with larger tasks.',

      q5: 'How many people can participate in a session?',
      a5: 'There is no fixed upper limit, but for optimal results we recommend 3-10 participants. This corresponds to the ideal size for Scrum teams and enables productive discussions.',

      q6: 'Can I link GitHub or GitLab issues?',
      a6: 'Yes! As a moderator, you can link GitHub or GitLab issues directly to your estimates. Simply enter the issue URL in the corresponding field. The issue details will then be visible to all participants.',

      q7: 'What happens if someone loses connection during the session?',
      a7: 'Planning Poker uses real-time synchronization. If someone loses connection and reloads the page, they can simply rejoin the session with the same name. The current round and all previous results are preserved.',

      q8: 'Are my estimates saved?',
      a8: 'Yes, all completed rounds are saved in the session history and can be viewed at any time. The data remains available for the duration of the session. For privacy reasons, sessions are automatically deleted after a certain period of inactivity.',

      q9: 'Can I use Planning Poker in Dark Mode?',
      a9: 'Yes! Simply click on the moon/sun icon in the top right to switch between light and dark design. Your preference will be saved for future visits.',

      q10: 'What do the statistics mean after voting?',
      a10: 'After revealing the cards, you will see several statistics:\n• Average: The arithmetic mean of all estimates\n• Median: The middle value (especially useful with outliers)\n• Min/Max: The lowest and highest estimate\n\nLarge deviations between Min and Max indicate that the team has different understandings of the task and a discussion would be helpful.',
    },
  },
}
